var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"sign1",staticClass:"disclaimer-wrapper primary-bd-ee"},[_c('span',{staticClass:"content sub-text-99"},[_vm._v(_vm._s(_vm.propsData.disclaimer))])])}
var staticRenderFns = []
export { render, staticRenderFns }